// src/utils/openDocSecure.js
import { authFetch } from "../services/auth";

function filenameFromHeaders(res, fallback = "archivo") {
  const cd = res.headers.get("Content-Disposition") || "";
  const mStar = cd.match(/filename\*\s*=\s*([^;]+)/i);
  if (mStar) {
    const v = mStar[1].trim();
    const idx = v.indexOf("''");
    if (idx >= 0) { try { return decodeURIComponent(v.slice(idx + 2)); } catch {} }
    return v.replace(/^"(.*)"$/, "$1");
  }
  const m = cd.match(/filename\s*=\s*"?(.*?)"?\s*(;|$)/i);
  if (m) return m[1];
  return fallback;
}

function looksPreviewable(ctype = "") {
  const t = (ctype || "").toLowerCase();
  return (
    t.includes("pdf") ||
    t.startsWith("image/") ||
    t.startsWith("text/") ||
    t.includes("json") ||
    t.includes("csv")
  );
}

function openWithAnchor(url, downloadName = null) {
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  if (downloadName) a.download = downloadName;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
}

/**
 * Intenta varias rutas típicas para servir el binario del documento.
 * Mantiene el comportamiento de previsualizar si el Content-Type lo permite.
 */
export async function openDocSecure(docId, fallbackName = "archivo") {
  // 1) abre una pestaña inmediata (evita bloqueos en algunos navegadores)
  const w = window.open("", "_blank");
  if (!w) console.warn("[openDocSecure] window.open bloqueado, uso <a target=_blank>.");

  // rutas candidatas (primero tu endpoint actual)
  const candidates = [
    `/api/documentos/${docId}/download`,   // tu ruta actual
    `/api/documentos/${docId}/ver`,        // alternativa frecuente
    `/api/documentos/${docId}/descargar`,  // alternativa frecuente
    `/api/documentos/${docId}`,            // fallback genérico
  ];

  let lastErr = null;

  for (const url of candidates) {
    try {
      console.debug("[openDocSecure] GET", url);
      const res = await authFetch(url, { method: "GET" });
      if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);

      const ctype = res.headers.get("Content-Type") || "";
      const blob = await res.blob();
      const objUrl = URL.createObjectURL(blob);
      const fname = filenameFromHeaders(res, fallbackName);

      console.debug("[openDocSecure] OK", url, "ctype:", ctype || "(vacío)");

      if (looksPreviewable(ctype)) {
        if (w) {
          w.location.replace(objUrl);
          setTimeout(() => URL.revokeObjectURL(objUrl), 60_000);
        } else {
          openWithAnchor(objUrl);
          setTimeout(() => URL.revokeObjectURL(objUrl), 60_000);
        }
      } else {
        if (w) { try { w.close(); } catch {} }
        openWithAnchor(objUrl, fname || "archivo");
        setTimeout(() => URL.revokeObjectURL(objUrl), 4000);
      }
      return; // éxito, salimos
    } catch (e) {
      console.debug("[openDocSecure] fallo en", url, "→", e?.message || e);
      lastErr = e;
      // sigue probando con la siguiente ruta
    }
  }

  // si ninguna ruta funcionó:
  console.error("[openDocSecure] no se pudo abrir", docId, lastErr);
  if (w && !w.closed) {
    w.document.write(
      `<p style="font-family:sans-serif;color:#b00;padding:16px">Error abriendo documento: ${lastErr?.message || lastErr}</p>`
    );
  } else {
    alert(`Error abriendo documento: ${lastErr?.message || lastErr}`);
  }
}
